import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-premies-jaarruimte',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-premies-jaarruimte.component.html',
  styleUrl: './tekst-premies-jaarruimte.component.scss',
})
export class TekstPremiesJaarruimteComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();

  public maxReserveringsruimte = 0;

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
      if (this.year == 2024) {
        this.maxReserveringsruimte = 41608
      }
      if (this.year == 2025) {
        this.maxReserveringsruimte = 42108
      }
     })
  }

}
